module.exports = __webpack_public_path__ + "static/w2-c0316d0719fff2c75c539dcb1a762c7d.jpg";